import { useState } from "react";
import { findCountryPlaceholder } from "../../../lib/countries/countries.utils";

import type { UseFormRegisterReturn } from "react-hook-form";

type SimplePhoneInputProps = {
  countryCode?: string;
  onChange?: (phoneNumber: string) => void;
  register?: UseFormRegisterReturn
  id?: string;
  registerValue?: string;
}

const SimplePhoneInput: React.FC<SimplePhoneInputProps> = ({
  countryCode,
  onChange,
  registerValue,
  id,
  register
}) => {
  const [phoneNumber, setPhoneNumber] = useState<string | undefined>(registerValue)
  const [placeholder] = useState<string | undefined>(findCountryPlaceholder(countryCode));
  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newPhoneNumber = e.target.value;
    setPhoneNumber(newPhoneNumber);
    if (onChange) {
      onChange(newPhoneNumber);
    }
  };

  return (
    <div className="relative flex">
      <input
        type="tel"
        value={phoneNumber}
        {...register}
        onChange={handlePhoneNumberChange}
        placeholder={placeholder}
        id={id}
        className={`dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent py-3 px-4 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800`}
      />
    </div>
  );
};

export default SimplePhoneInput;
